RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.PlanRestriction = Marionette.ItemView.extend({
        template: '#planRestrictionTemplate',
        className: 'plan-restriction panel-body'
    });
});
